
import React from 'react';
import { cn } from "@/lib/utils";

interface TableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
}

const TableCell = ({ children, className, ...props }: TableCellProps) => {
  return (
    <td
      className={cn(
        "p-4 whitespace-nowrap",
        className
      )}
      {...props}
    >
      {children}
    </td>
  );
};

export default TableCell;
